import { render, staticRenderFns } from "./xxjs.vue?vue&type=template&id=07d86cb9&scoped=true&"
import script from "./xxjs.vue?vue&type=script&lang=js&"
export * from "./xxjs.vue?vue&type=script&lang=js&"
import style0 from "./xxjs.vue?vue&type=style&index=0&id=07d86cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d86cb9",
  null
  
)

component.options.__file = "xxjs.vue"
export default component.exports